// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_92af29d0","container":"_c2fc2104","isLoading":"_64c3ec9f","labelText":"_662e8758","tileContainer":"_6f0e09b0","projectTile":"_87db11a2"};